import { GET_PAYMENT_LIST } from "../components/Shared/constant";

const  GetpaymentList= async (accessToken, userSearch, userType, userLimit, currentPage,{ signal } = {}) => {
    const responce = window.axios.get(`${GET_PAYMENT_LIST}/${userType}/${userLimit}/${currentPage}`, {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken,
    },
    signal: signal,
  }).then(function (result) {
        return {
          ...result.data,
          status:200
        };
    }).catch(function (result) {
        return {
          ...result?.response?.data,
          status:result?.response?.status
        }
    });
    return responce;
};
  
export default GetpaymentList;